export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11668.feaf8cd3.jpg";